import React from 'react'
import Form from './Form'
import { BatchLookupTxSetFieldTypes } from 'types/bulkTransactionsTXTypes'

const Index: React.FC<{
  isBatchLookupToggle: boolean
  setFieldValue: BatchLookupTxSetFieldTypes
  title?: string;
  placeholder?: string;
}> = ({ isBatchLookupToggle, setFieldValue, title , placeholder}): React.ReactElement => {
  if (!isBatchLookupToggle) return <></>
  return <Form setFieldValue={setFieldValue} title={title} placeholder={placeholder}/>
}

export default Index
